import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import PurchaseOrderService from "services/Setup/LoanOrigination/PurchaseOrder/PurchaseOrderService";
import { notification } from "antd";

const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  result: null,
  getCount: null,
  purchaseOrderList: null,
  refreshList: false,
  statusRespon: null,
};

export const getPurchaseOrderItemsSlice = createAsyncThunk(
  "purchaseOrder/getPurchaseOrderItemsSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseOrderService.getGetPurchaseOrderItemService(payload);

      const data = response.data;

      if (response.status === 200) {
        return data;
      } else {
        notification.error({
          message: data.status,
          description: data.message,
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.response?.data?.message || "Request failed",
        duration: 3,
      });

      return rejectWithValue(error.response?.data?.message || "Request failed");
    }
  }
);

export const addGetPurchaseOrderSlice = createAsyncThunk(
  "purchaseOrder/addGetPurchaseOrderSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PurchaseOrderService.addGetPurchaseOrderService(
        payload
      );
      console.log("addGetPurchaseOrderSlice response:", response);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.response?.data?.message || "Request failed",
        duration: 3,
      });

      return rejectWithValue(error.response?.data?.message || "Request failed");
    }
  }
);

export const approvePurchaseOrderSlice = createAsyncThunk(
  "purchaseOrder/approvePurchaseOrderSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PurchaseOrderService.approvePurchaseOrderService(
        payload
      );
      console.log("addGetPurchaseOrderSlice response:", response);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.response?.data?.message || "Request failed",
        duration: 3,
      });

      return rejectWithValue(error.response?.data?.message || "Request failed");
    }
  }
);

export const getSearchListPoApprovalSlice = createAsyncThunk(
  "purchaseOrder/getSearchListPoApprovalSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseOrderService.getSearchListPoApprovalService(payload);

      const data = response.data;

      if (response.status === 200) {
        return data;
      } else {
        notification.error({
          message: data.status,
          description: data.message,
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.response?.data?.message || "Request failed",
        duration: 3,
      });

      return rejectWithValue(error.response?.data?.message || "Request failed");
    }
  }
);

export const getSearchListPoReleaseSlice = createAsyncThunk(
  "purchaseOrder/getSearchListPoReleaseSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PurchaseOrderService.getSearchListPoReleaseService(
        payload
      );

      const data = response.data;

      if (response.status === 200) {
        return data;
      } else {
        notification.error({
          message: data.status,
          description: data.message,
          duration: 3,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.response?.data?.message || "Request failed",
        duration: 3,
      });

      return rejectWithValue(error.response?.data?.message || "Request failed");
    }
  }
);

export const putPrintPurchaseOrderSlice = createAsyncThunk(
  "purchaseOrder/putPrintPurchaseOrderSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PurchaseOrderService.putPrintPurchaseOrderService(
        payload
      );
      console.log("addGetPurchaseOrderSlice response:", response);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.response?.data?.message || "Request failed",
        duration: 3,
      });

      return rejectWithValue(error.response?.data?.message || "Request failed");
    }
  }
);

// putSendEmailPurchaseOrderService
export const putSendEmailPurchaseOrderSlice = createAsyncThunk(
  "purchaseOrder/putSendEmailPurchaseOrderSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response =
        await PurchaseOrderService.putSendEmailPurchaseOrderService(payload);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.response?.data?.message || "Request failed",
        duration: 3,
      });
      return rejectWithValue(error.response?.data?.message || "Request failed");
    }
  }
);

export const rejectPurchaseOrderSlice = createAsyncThunk(
  "purchaseOrder/rejectPurchaseOrderSlice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await PurchaseOrderService.rejectPurchaseOrderService(
        payload
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error.response?.data?.message || "Request failed",
        duration: 3,
      });

      return rejectWithValue(error.response?.data?.message || "Request failed");
    }
  }
);

const PurchaseOrderSlice = createSlice({
  name: "purchaseOrder",
  initialState,
  reducers: {
    hideNotification(state) {
      state.message = "";
      state.showMessage = false;
    },
    resetStatusRespon(state) {
      state.statusRespon = null;
      state.loading = false;
    },
    resetState(state) {
      state.statusRespon = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseOrderItemsSlice.pending, (state) => {
        state.loading = true;
        state.refreshList = false;
      })
      .addCase(getPurchaseOrderItemsSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.purchaseOrderList = action.payload;
        state.getCount = action.payload.data.count;
      })
      .addCase(getPurchaseOrderItemsSlice.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })
      .addCase(addGetPurchaseOrderSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(addGetPurchaseOrderSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.statusRespon = action.payload.status;
        state.refreshList = true;
      })
      .addCase(addGetPurchaseOrderSlice.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })

      .addCase(approvePurchaseOrderSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(approvePurchaseOrderSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.statusRespon = action.payload.status;
        state.refreshList = true;
      })
      .addCase(approvePurchaseOrderSlice.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })

      .addCase(getSearchListPoApprovalSlice.pending, (state) => {
        state.loading = true;
        state.refreshList = false;
      })
      .addCase(getSearchListPoApprovalSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.purchaseOrderList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getSearchListPoApprovalSlice.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })
      // getSearchListPoReleaseSlice
      .addCase(getSearchListPoReleaseSlice.pending, (state) => {
        state.loading = true;
        state.refreshList = false;
      })
      .addCase(getSearchListPoReleaseSlice.fulfilled, (state, action) => { 
        
        state.loading = false;
        state.purchaseOrderList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getSearchListPoReleaseSlice.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })

      .addCase(putPrintPurchaseOrderSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(putPrintPurchaseOrderSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.statusRespon = action.payload.status;
      })
      .addCase(putPrintPurchaseOrderSlice.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })

      // putSendEmailPurchaseOrderService
      .addCase(putSendEmailPurchaseOrderSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(putSendEmailPurchaseOrderSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.statusRespon = action.payload.status;
      })
      .addCase(putSendEmailPurchaseOrderSlice.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      })
      // rejectPurchaseOrderSlice
      .addCase(rejectPurchaseOrderSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(rejectPurchaseOrderSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.statusRespon = action.payload.status;
        state.refreshList = true;
      })
      .addCase(rejectPurchaseOrderSlice.rejected, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.showMessage = true;
      });
  },
});

export const { hideNotification, resetStatusRespon, resetState } =
  PurchaseOrderSlice.actions;

export default PurchaseOrderSlice.reducer;
